import { schema } from 'normalizr'

export const lineSchema = new schema.Entity('continuousRoutes')
